import React from 'react';

const PageNotFound = () => (
  <div className="container-inner" style={{ marginTop: '50px' }}>
    404 - Page not found
  </div>
);

export default PageNotFound;
